<script setup lang="ts">
withDefaults(defineProps<{
  title?: string
  subtitle?: string
  scrollableContent?: boolean
  noPadding?: boolean
}>(), {
  scrollableContent: true,
})

defineEmits<{
  close: []
}>()
</script>

<template>
  <div class="flex items-center justify-between border-b border-gray-200 p-4 dark:border-gray-700">
    <div class="flex flex-1 items-center">
      <slot name="header">
        <div v-if="$slots.backButton" class="mr-4">
          <slot name="backButton" />
        </div>
        <div>
          <div class="flex items-center space-x-3">
            <PageTitle v-if="title" :title="title" :without-margin="true" size="md" />
            <slot name="after-title" />
          </div>
          <div v-if="subtitle" class="text-sm text-gray-600 dark:text-gray-400">
            {{ subtitle }}
          </div>
        </div>
      </slot>
    </div>
    <UButton icon="light:xmark" variant="ghost" size="xl" color="gray" @click="$emit('close')" />
  </div>

  <div class="flex min-h-px flex-1 flex-col" :class="{ 'overflow-y-auto': scrollableContent, 'p-4': !noPadding }">
    <slot />
  </div>

  <div v-if="$slots.footer" class="flex justify-end gap-2 border-t border-gray-200 p-4 dark:border-gray-700">
    <slot name="footer" />
  </div>
</template>
